import React, {Component} from "react";
import PropTypes from "prop-types";
import {CenteredSpinner} from "@stacc/flow-ui-components";
import fileService from "../services/files";
import ImageViewer from "./documentsViewer/ImageViewer";
import PdfViewer from "./documentsViewer/PdfViewer";
import {Buffer} from 'buffer';

class FileDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            file: null
        };
        this.bpiClientConfig = props.bpiClientConfig;
        this.fileType = props.fileType;
    }

    componentDidMount() {
        const {fileId, isDocAttachment, isBase64EncodedDocAttachment} = this.props;
        this.setState({isLoading: true});

        const file = isDocAttachment ?
            fileService.getDocAttachmentsFile(this.bpiClientConfig, fileId) :
            fileService.getFile(fileId);
        file.then(result => {
            if (result) {
                this.setState({
                    file: {
                        fileId,
                        type: this.fileType ? this.fileType : result.type,
                        file: isBase64EncodedDocAttachment ?
                            Buffer.fromBase64(new TextDecoder().decode(result.file)) :
                            result.file
                    },
                    isLoading: false
                });
            } else {
                this.setState({file: null, isLoading: false});
            }
        });
    }

    render() {
        const {file, isLoading} = this.state;
        if (isLoading) {
            return <CenteredSpinner/>;
        }
        if (!file) {
            return null;
        }

        const fileType = this.fileType ? this.fileType : file.type;
        if (fileType.includes("image")) {
            return <ImageViewer file={file.file} type={fileType}/>;
        }

        if (fileType.includes("pdf")) {
            return <PdfViewer file={file.file} fileId={file.id}/>;
        }
        return null;
    }
}

FileDisplay.propTypes = {
    fileId: PropTypes.string.isRequired,
    isDocAttachment: PropTypes.bool,
    fileType: PropTypes.string,
};

export default FileDisplay;
